import {Injectable} from '@angular/core';
import {StaticsService} from './statics.service';
import {Subject} from 'rxjs';

declare var $: any;

@Injectable()
export class SettingsService {
    //This class should never have a set method.
    public settingsServiceInitializeSubject = new Subject<boolean>();

    constructor(private staticsService: StaticsService) {}

    private settings: Array<string>;

    public initialize(data) {
        let localSettings: Array<string> = [];
        $.each(data, function(key, val) {
            localSettings[key] = val;
        });
        this.settings = localSettings;
        this.settingsServiceInitializeSubject.next(true);
    }

    getProperty(key: string) {
        let property = this.settings[key];
        return property ? this.settings[key] : "";
    }

    public append(data) {
        let localSettings = this.settings;
        $.each(data, function(key, val) {
            localSettings[val.key] = val.setting;
        });
        this.settings = localSettings;
    }

    public getServiceAwsHostname() {
        return this.settings['serviceAwsHostname'];
    }

    public getServiceAwsApp() {
        return this.settings['serviceAwsApp'];
    }

    public getServicePdfPath() {
        return this.settings['servicePdfPath'];
    }
    
    public getServiceBaseUrl() {
        return this.getServiceAwsHostname() + this.getServiceAwsApp();
    }

    public getServiceAwsParser() {
        return this.settings['serviceAwsParser'];
    }

    public getNgHostname(): string {
        return (this.settings['ngHostname']);
    }

    public getRecordsMax(): string {
        return (this.settings['recordsMax']);
    }

    public getRecordsMaxTotal(): string {
        return (this.settings['recordsMaxTotal']);
    }

    public getHelpLink(): string {
        return (this.settings['helpLink']);
    }

    public getAFSDDLink(): string {
        return (this.settings['AFSDDLink']);
    }
    public getForm5500SeriesDDLink(): string {
        return (this.settings['Form5500SeriesDDLink']);
    }

}